import { render, staticRenderFns } from "./shopVipUser.vue?vue&type=template&id=7c10a926&scoped=true"
import script from "./shopVipUser.vue?vue&type=script&lang=js"
export * from "./shopVipUser.vue?vue&type=script&lang=js"
import style0 from "./shopVipUser.vue?vue&type=style&index=0&id=7c10a926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c10a926",
  null
  
)

export default component.exports